import { render, staticRenderFns } from "./RealityReminder.vue?vue&type=template&id=a9483eb4&scoped=true"
import script from "./RealityReminder.vue?vue&type=script&lang=js"
export * from "./RealityReminder.vue?vue&type=script&lang=js"
import style0 from "./RealityReminder.vue?vue&type=style&index=0&id=a9483eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9483eb4",
  null
  
)

export default component.exports